import { render, staticRenderFns } from "./FreeBoxSlideList.vue?vue&type=template&id=4ad4ba7e&scoped=true&"
import script from "./FreeBoxSlideList.vue?vue&type=script&lang=ts&"
export * from "./FreeBoxSlideList.vue?vue&type=script&lang=ts&"
import style0 from "./FreeBoxSlideList.vue?vue&type=style&index=0&id=4ad4ba7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad4ba7e",
  null
  
)

export default component.exports